const fbShareWhiteSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="437.036px" height="463.612px" viewBox="15.406 -0.001 437.036 463.612"
	 enable-background="new 15.406 -0.001 437.036 463.612" xml:space="preserve">
<g>
	<path fill="#FFFFFF" d="M369.47,297.842c-26.662,0-50.449,12.705-65.647,32.342l-127.365-71.137
		c2.977-8.572,4.616-17.813,4.616-27.345c0-9.615-1.64-18.762-4.717-27.435l127.264-71.034
		c15.126,19.736,38.991,32.522,65.753,32.522c45.627,0,82.879-37.149,82.879-82.872c0-45.727-37.155-82.884-82.879-82.884
		c-45.726,0-82.889,37.157-82.889,82.884c0,9.616,1.639,18.87,4.715,27.436l-127.166,71.046
		c-15.117-19.837-38.987-32.535-65.732-32.535c-45.644,0-82.896,37.15-82.896,82.872c0,45.734,37.251,82.89,82.979,82.89
		c26.764,0,50.641-12.801,65.851-32.625l127.256,71.129c-3.069,8.666-4.811,18.01-4.811,27.631
		c0,45.627,37.151,82.885,82.878,82.885c45.729,0,82.884-37.164,82.884-82.885C452.442,335,415.191,297.842,369.47,297.842z
		 M369.47,26.086c31.389,0,56.892,25.51,56.892,56.887c0,31.39-25.503,56.899-56.892,56.899c-31.385,0-56.894-25.51-56.894-56.899
		C312.578,51.596,338.187,26.086,369.47,26.086z M98.385,288.601c-31.384,0-56.893-25.516-56.893-56.9
		c0-31.372,25.509-56.887,56.893-56.887c31.385,0,56.9,25.515,56.9,56.887C155.285,263.086,129.675,288.601,98.385,288.601z
		 M369.47,437.517c-31.385,0-56.894-25.502-56.894-56.887s25.509-56.887,56.894-56.887c31.389,0,56.892,25.502,56.892,56.887
		S400.859,437.517,369.47,437.517z"/>
</g>
<g display="none">
	<path display="inline" fill="#3B5998" d="M741.93,34.817c69.452,0,125.748,56.306,125.748,125.754
		c0,69.455-56.296,125.749-125.748,125.749c-69.463,0-125.757-56.294-125.757-125.749C616.175,91.122,672.469,34.817,741.93,34.817z
		"/>
	<path display="inline" fill="#FFFFFF" d="M773.532,165.489H751.1v82.206h-33.998v-82.206h-16.167v-28.895h16.167v-18.697
		c0-13.363,6.35-34.294,34.307-34.294l25.176,0.101v28.046H758.31c-2.988,0-7.21,1.497-7.21,7.875v17.004h25.42L773.532,165.489z"/>
</g>
</svg>
`;

export default fbShareWhiteSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/fbShareWhiteSVG.js